import {module} from "angular"
import "angular-ui-router"

export const integrationDocumentationModule = module("integrationDocumentationModule", [
    "ui.router"
])